import {takeLatest} from 'redux-saga/effects';
import {fetchProfile, ProfileTypes, updateProfile} from '../reducers/profile';

const ProfileSagas = [
  takeLatest(ProfileTypes.UPDATE_PROFILE_REQUEST, updateProfile),
  takeLatest(ProfileTypes.FETCH_PROFILE_REQUEST, fetchProfile),
];

export default ProfileSagas;
